function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import isString from "lodash/isString";
import classNames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import { preventFocusOnMouseDown, setSVGTitle } from "client/services/accessibility/accessibility-service";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants";
import PricingCheck from "/static/svg/pricing-check.svg";
import PricingInfoIcon from "/static/svg/pricing-info-icon.svg";
import { StyledPlanFeatureValueComponent } from "./plan-feature-value-component.scss";
const isObject = (value)=>typeof value === "object" && value !== null;
class PlanFeatureValueComponent extends PureComponent {
    componentDidMount() {
        // setting the 'aria-label' value to either the cell itself, or the checkmark SVG within it.
        const { featureValue } = this.props;
        if (featureValue === true) {
            // value is a boolean true, i.e. a checkmark is rendered
            setSVGTitle(`#${this.getFeatureValueCellID()}`, this.getFeatureAriaLabel());
        } else {
            document.getElementById(this.getFeatureValueCellID()).setAttribute("aria-label", this.getFeatureAriaLabel());
        }
    }
    render() {
        const { tier, featureValue, featureInfo, translateOrTranslateWithParam, planWidth } = this.props;
        const planFeatureStyle = {
            width: `${planWidth}%`
        };
        return /*#__PURE__*/ _jsxs(StyledPlanFeatureValueComponent, {
            id: this.getFeatureValueCellID(),
            className: classNames("plan-feature-value-component", tier),
            onMouseDown: preventFocusOnMouseDown,
            role: "cell",
            style: planFeatureStyle,
            children: [
                featureValue === true && /*#__PURE__*/ _jsx("div", {
                    className: classNames(`check-circle ${tier}`),
                    children: /*#__PURE__*/ _jsx(PricingCheck, {})
                }),
                (isString(featureValue) || isObject(featureValue)) && /*#__PURE__*/ _jsx("span", {
                    className: "plan-feature-name",
                    children: translateOrTranslateWithParam(featureValue)
                }),
                featureInfo && /*#__PURE__*/ _jsxs("div", {
                    className: classNames("plan-feature-info", {
                        "with-string-value": isString(featureValue)
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(PricingInfoIcon, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: "plan-feature-info-tooltip-container",
                            children: /*#__PURE__*/ _jsx(TooltipComponent, {
                                theme: DARK_THEME,
                                className: "floating-tooltip",
                                children: translateOrTranslateWithParam(featureInfo)
                            })
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "getFeatureValueCellID", ()=>{
            const { tier, featureName, indexInSection } = this.props;
            return `featureTierValue_${featureName.replace(/\./g, "_")}_${tier}_${indexInSection}`;
        });
        _define_property(this, "getBooleanValueString", (value)=>{
            const { translate } = this.props;
            return value ? translate("pricingPage.included") : translate("pricingPage.notIncluded");
        });
        _define_property(this, "getFeatureAriaLabel", ()=>{
            const { plan, featureValue, featureName, translate } = this.props;
            const { displayName } = plan;
            const value = isString(featureValue) ? translate(featureValue) : this.getBooleanValueString(featureValue);
            return `${translate(displayName)}: ${translate(featureName)}. ${value}.`;
        });
    }
}
export default withGenericConfig(PlanFeatureValueComponent);
